import { c as _c } from "react/compiler-runtime";
import { BulkExportGroups } from "@components/table/groups/bulk-actions/bulk-export-groups";
import { useShouldShowBulkAction } from "@hooks/table/use-should-show-bulk-action";
import { useAppSelector } from "@store/store-helper";
import { fetchingGroupsFlagsSelector } from "@store/groups/groups-selector";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { useMemo } from "react";
/** List all the bulk action components for group table */
export function useGroupsPageBulkActions(t0) {
  const $ = _c(14);
  const {
    groups
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("groups");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const {
    isFetchingGroups
  } = useAppSelector(fetchingGroupsFlagsSelector);
  const isAnyRowSelected = selectedEntities.length !== 0;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["export"];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const allowedButtons = t2;
  const allowedButtonsBasedOnRowSelection = allowedButtons;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      allowedButtonsBasedOnRowSelection
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    shouldShowBulkButtons
  } = useShouldShowBulkAction(t3);
  let t4;
  if ($[3] !== groups || $[4] !== isFetchingGroups || $[5] !== shouldShowBulkButtons) {
    t4 = shouldShowBulkButtons("export") && (isFetchingGroups || groups.length > 0);
    $[3] = groups;
    $[4] = isFetchingGroups;
    $[5] = shouldShowBulkButtons;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const shouldShowExportButton = t4;
  let t5;
  if ($[7] !== groups || $[8] !== isAnyRowSelected || $[9] !== selectedEntities || $[10] !== shouldShowExportButton) {
    t5 = shouldShowExportButton ? <BulkExportGroups selectedGroups={isAnyRowSelected ? selectedEntities : groups} areEntitiesSelected={isAnyRowSelected} /> : null;
    $[7] = groups;
    $[8] = isAnyRowSelected;
    $[9] = selectedEntities;
    $[10] = shouldShowExportButton;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = {
      export: t5
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}